export default __webpack_public_path__ + "static/char-s-59-ko-5196c49a3582a3bf8812b2c03ff05492.png";